export default "__VITE_ASSET__d0f6268d__"